<template>
    <div>
        <Breadcrumb section-name="Project" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <a class="me-2 btn btn-option mb-2" href="javascript:void(0)" @click="downloadFile" title="Print">
                        <img v-if="!exportLoading" class="print" width="16" height="16"/>
                        <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status"
                              aria-hidden="true"></span>
                    </a>
                    <table class="table mb-0 table-striped table-bordered dataTable">
                        <thead>
                            <tr>
                                <th>Sl</th>
                                <th>ID Number</th>
                                <th>Shareholder Name</th>
                                <th class="text-center">No of Share</th>
                                <th>Whatsapp Number</th>
                                <th>Land Purchase Date</th>
                                <th class="text-end">Land Purchase Price</th>
                                <th class="text-end">Total Deposit</th>
                            </tr>
                        </thead>
                        <tbody v-if="!loading && shareholders.length > 0">
                            <tr v-for="(each,index) in shareholders">
                                <td v-text="index + 1"></td>
                                <td>
                                    <router-link :to="{name: 'shareholderDailyReport', params:{project_id: this.$route.params.id, shareholder_id: each.id}}">{{ each.id_number }}</router-link>
                                </td>
                                <td>
                                    <router-link :to="{name: 'shareholderDailyReport', params:{project_id: this.$route.params.id, shareholder_id: each.id}}">{{ each.shareholder_name }}</router-link>
                                </td>
                                <td class="text-center" v-text="each.total_share"></td>
                                <td v-text="each.whatsapp_number"></td>
                                <td v-text="each.land_purchase_date"></td>
                                <td class="text-end" v-text="each.land_purchase_price"></td>
                                <td class="text-end" v-text="each.total_deposit"></td>
                            </tr>
                            <tr>
                                <th colspan="3" class="text-end">Total</th>
                                <th class="text-center" v-text="total.total_share"></th>
                                <th colspan="3"></th>
                                <th class="text-end" v-text="total.total_deposit"></th>
                            </tr>
                        </tbody>
                        <tbody v-if="loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-if="shareholders.length === 0">
                            <tr class="text-center">
                                <td colspan="100" class="fw-bold fs-6 text-height">
                                    No Data Found
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Loader from "../Common/Loader.vue";
import DownloadService from "../../Services/DownloadService";
export default {
    components: {Loader, Breadcrumb},
    data() {
        return {
            breadCrumb: [],
            shareholders: [],
            loading: false,
            total: {},
            exportLoading: false,
        }
    },
    watch: {

    },
    methods: {
        fetchShareholderByProject: function() {
            this.loading = true;
            ApiService.POST(ApiRoutes.Dashboard + '/shareholderByProject', {project_id: this.$route.params.id}, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.shareholders = res.data;
                    this.total = res.total;
                    this.breadCrumb.push(res.project_name);
                }
            });
        },
        downloadFile: function () {
            PrintService.print('/print/shareholderByProject?project_id=' + this.$route.params.id);
        },
    },
    mounted() {
        this.fetchShareholderByProject();
    },
    created() {
    }
}
</script>
